// handles document sections for the sidebar for scrolling to a section when clicked
import React, { createContext, useContext, useState } from "react";

const DocumentSectionsContext = createContext();

export const DocumentSectionsProvider = ({ children }) => {
  const [sections, setSections] = useState([]);

  const handleSectionClick = (section) => {
    if (section?.dataField) {
      const el = document.getElementById(section.dataField);
      if (el) {
        // Scroll the AppShell content area when present.
        const scrollContainer = document.querySelector(".app-shell-content");
        if (scrollContainer) {
          const y = el.getBoundingClientRect().top + scrollContainer.scrollTop - 200;
          scrollContainer.scrollTo({ top: y, behavior: "smooth" });
        } else {
          const y = el.getBoundingClientRect().top + window.pageYOffset - 200;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }
    }
  };

  return (
    <DocumentSectionsContext.Provider value={{ sections, setSections, handleSectionClick }}>
      {children}
    </DocumentSectionsContext.Provider>
  );
};

export const useDocumentSections = () => {
  return useContext(DocumentSectionsContext);
};
